import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Typography,
  DialogActions,
  DialogContentText,
  Stack,
  Box,
  Alert,
  Snackbar,
  Link,
} from "@mui/material";

import login from "../../api/user/login";
import api from "../../api/api"
import { AuthContext } from "../../context/AuthContext";



const ACCENT = "#02a4e3";
const BG = "#2B232D";
const WHITE = "#fff";

// 共用 TextField 樣式
const textFieldSx = {
  "& .MuiInputLabel-root": { color: WHITE },
  "& .MuiInputLabel-root.Mui-focused": { color: ACCENT },
  "& .MuiOutlinedInput-root": {
    color: WHITE,
    "& fieldset": { borderColor: ACCENT },
    "&:hover fieldset": { borderColor: ACCENT },
    "&.Mui-focused fieldset": { borderColor: ACCENT },
  },
};

const actionPrimaryBtnSx = {
  fontWeight: "bold",
  backgroundColor: ACCENT,
  color: WHITE,
  "&:hover": { backgroundColor: "#0190be" },
};

const actionOutlineBtnSx = {
  color: ACCENT,
  border: `1px solid ${ACCENT}`,
  "&:hover": {
    border: `1px solid ${ACCENT}`,
    backgroundColor: "rgba(2,164,227,0.08)",
  },
};

const paperProps = {
  sx: {
    backgroundColor: BG,
    color: WHITE,
    borderRadius: 2,
    boxShadow: "0 8px 32px rgba(2,164,227,0.25)",
    minWidth: { xs: 320, sm: 420 },
  },
};

const LoginDialogs = ({ openLogin, handleLoginClose, setToken }) => {


  const userContext = useContext(AuthContext);

  /* Login */
  const [loginData, setLoginData] = useState({
    phone: "",
    password: "",
    email: "",
  });

  /* Register */
  const [phone, setPhone] = useState("");

  const [password, setPassword] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordNotMatch, setPasswordNotMatch] = useState(false);
  const [phoneError, setPhoneError] = useState(false);



  /* Global */
  const [snakeOpen, setSnakeOpen] = useState(false);
  const [snakeMsg, setSnakeMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(null);
  const [alertHidden, setAlertHidden] = useState(true);



  useEffect(() => {
    if (error === "" || error === null || isNaN(error)) {
      setAlertHidden(true);
    } else {
      setAlertHidden(false);
    }
  }, [error]);

  useEffect(() => {
    if (openLogin) {
      setError("");
      setLoginData({ phone: "", password: "" });
    }
  }, [openLogin]);

  useEffect(() => {
    setPasswordNotMatch(
      !(password === "" && confirmPassword === "") && password !== confirmPassword
    );
  }, [password, confirmPassword]);

  useEffect(() => {
    setPhoneError(phone !== "" && phone.length !== 10);
  }, [phone]);







  const handleLoginButtonClick = async () => {
    setLoading(true);
    try {
      const responseData = await login(loginData.phone, loginData.password);
      if (responseData !== null) {
        handleLoginClose();
        localStorage.setItem("token", responseData.token);
        api.defaults.headers.common["Authorization"] = `Bearer ${responseData.token}`;
        userContext.setUser(responseData.user);
        setSnakeMsg("登入成功。");
        setToken(responseData.token);
        setSnakeOpen(true);
      } else {
        setError(responseData.message);
      }
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Login */}
      <Dialog open={openLogin} onClose={handleLoginClose} PaperProps={paperProps}>
        <DialogTitle sx={{ fontWeight: "bold", color: WHITE }}>
          登入
          <Button
            aria-label="close"
            onClick={handleLoginClose}
            sx={{
              position: "absolute",
              right: 6,
              top: 10,
              color: WHITE,
              minWidth: 0,
            }}
          >
            x
          </Button>
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            variant="outlined"
            margin="dense"
            id="username"
            label="帳號"
            value={loginData.phone}
            onChange={(e) =>
              setLoginData((prev) => ({ ...prev, phone: e.target.value }))
            }
            type="text"
            fullWidth
            sx={textFieldSx}
          />
          <TextField
            margin="dense"
            id="password"
            label="密碼"
            value={loginData.password}
            onChange={(e) =>
              setLoginData((prev) => ({ ...prev, password: e.target.value }))
            }
            type="password"
            fullWidth
            sx={textFieldSx}
          />

          {!alertHidden && error !== "" ? (
            <Alert
              icon={false}
              severity="warning"
              sx={{ mt: 1, backgroundColor: "transparent", color: WHITE, border: `1px solid ${ACCENT}` }}
            >
              {error}
            </Alert>
          ) : null}


        </DialogContent>

        <DialogActions>

          <Box sx={{ flexGrow: 2 }} />
          <Button
            variant="contained"
            sx={{ ...actionPrimaryBtnSx, flexGrow: 1 }}
            disabled={loading}
            onClick={handleLoginButtonClick}
          >
            {loading ? "登入中..." : "登入"}
          </Button>
        </DialogActions>
      </Dialog>






      <Snackbar
        open={snakeOpen}
        autoHideDuration={5000}
        onClose={(event, reason) => {
          if (reason === "clickaway") return;
          setSnakeOpen(false);
        }}
        message={snakeMsg}
      />
    </div>
  );
};

export default LoginDialogs;
